import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/user/user.service';
import { Constants } from 'src/app/app.constants';

@Pipe({
  name: 'translateSignIn',
  pure: false
})
export class TranslateSignInPipe implements PipeTransform {
  constructor(private httpClient: HttpClient,
    private userService: UserService) { }
  private result: any = null;
  transform(value: string, args?: any) {
    this.result = null;
    const obj = this.userService.getSessionItem(Constants.OrgSpecificResource);
    if (obj && obj != undefined) {
      const data = JSON.parse(obj);
      this.result = data[value];
    }
    return this.result;
  }

}
